<template>
  <loader v-if="$store.state.loading" />
  <router-view></router-view>
</template>

<script>
import Loader from './components/Loader.vue'

export default {
  name: 'App',
  components: {
    Loader
  },
  mounted() {
    if (this.$store.state.darkMode) {
      document.body.classList.add('dark-mode');
    }
  }
}
</script>

<style lang="scss">
//Dashkit theme
@import './theme/scss/theme.scss';

</style>
